import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import typeCollaboration from "../manage/marketer/type-collaboration";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import { connect } from "react-redux";

function UserMarketerInfo({
  firstNameUser,
  lastNameUser,
  email,
  mobile,
  userID,
  role,
}) {
  const [userMarketerInfo, setUserMarketerInfo] = useState();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    getUserMarketerInfo();
  }, []);

  const getUserMarketerInfo = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllSiteUserAdvertiser =
      await sendRequestGetUserMarketerInfo();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllSiteUserAdvertiser) {
      return;
    }

    setUserMarketerInfo(resultSendRequestGetAllSiteUserAdvertiser);
  };

  const sendRequestGetUserMarketerInfo = async () => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/info",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اطلاعات بازاریاب" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>
                {userMarketerInfo && (
                  <div className="table-responsive">
                    <table className="table table-hilite m-0">
                      <thead>
                        <tr>
                          <td
                            colSpan={2}
                            className="text-center"
                            style={{ borderRadius: "25px 25px 0 0" }}
                          >
                            <b>اطلاعات شما</b>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>شماره کاربری</td>
                          <td>{userID}</td>
                        </tr>
                        <tr>
                          <td>نام</td>
                          <td className="d-flex ">
                            <span className="pl-2">{firstNameUser}</span>
                            <span>{lastNameUser}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>ایمیل</td>
                          <td>{email}</td>
                        </tr>
                        <tr>
                          <td>شماره موبایل</td>
                          <td>
                            <span dir="ltr">
                              {helperNumbers.toPersianNum(
                                helperNumbers.presentMobileNumber(mobile)
                              )}{" "}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>شناسه بازاریابی</td>
                          <td>
                            <span>{userMarketerInfo.identity_marketer}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>درصد اولیه</td>
                          <td>
                            {helperNumbers.toPersianNum(
                              userMarketerInfo.first_percent
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>نوع همکاری</td>
                          <td>
                            {
                              typeCollaboration.getTypeCollaborationString()[
                                userMarketerInfo.type_collaboration
                              ]
                            }
                          </td>
                        </tr>

                        {userMarketerInfo.type_collaboration ==
                          typeCollaboration.typeCollaborationConstant
                            .WITH_UNLIMITED_PERMANENT_PERCENT && (
                          <tr>
                            <td>درصد دائمی</td>
                            <td>
                              {helperNumbers.toPersianNum(
                                userMarketerInfo.permanent_percent
                              )}
                            </td>
                          </tr>
                        )}

                        {userMarketerInfo.type_collaboration ==
                          typeCollaboration.typeCollaborationConstant
                            .WITH_LIMITED_PERMANENT_PERCENT && (
                          <>
                            <tr>
                              <td>درصد دائمی</td>
                              <td>
                                {helperNumbers.toPersianNum(
                                  userMarketerInfo.permanent_percent
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>تعداد درصد دائمی</td>
                              <td>
                                {helperNumbers.toPersianNum(
                                  userMarketerInfo.count_permanent_percent
                                )}
                              </td>
                            </tr>
                          </>
                        )}

                        <tr>
                          <td>وضعیت</td>
                          <td>
                            {userMarketerInfo.active ? (
                              <span class="badge badge-success">فعال</span>
                            ) : (
                              <span class="badge badge-danger">غیرفعال</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>تاریخ ثبت نام</td>
                          <td>
                            {helperNumbers.toPersianNum(
                              helpersTime.convertGregorianToJalali(
                                userMarketerInfo.created_at
                              ) +
                                " " +
                                userMarketerInfo.created_at.split(" ")[1]
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div>صفحه ثبت نام کاربر خارج داشبورد</div>
                            <div>برای دیدن صفحه باید از داشبورد خارج شوید</div>
                          </td>
                          <td>
                            <span>
                              <a
                                className="btn btn-info"
                                target="_blank"
                                href={`${process.env.REACT_APP_DOMAIN}/marketer/add-user-outside-panel/${userMarketerInfo.identity_marketer}`}
                              >
                                <i className="fa fa-globe"></i>
                              </a>
                            </span>
                            <span className="pr-2">
                              <span
                                className="btn btn-info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigator.clipboard.writeText(
                                    `${process.env.REACT_APP_DOMAIN}/marketer/add-user-outside-panel/${userMarketerInfo.identity_marketer}`
                                  );
                                  setCopied(true);
                                }}
                              >
                                <i className="fas fa-copy pl-2"></i>
                                {copied ? "کپی شد" : " کپی  "}{" "}
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    userID: state.main.userID,
    firstNameUser: state.main.firstNameUser,
    lastNameUser: state.main.lastNameUser,
    email: state.main.email,
    mobile: state.main.mobile,
    role: state.main.role,
  };
};

export default connect(mapStateToProps, null)(UserMarketerInfo);
